export const aftcabinImageOptions = {
  angle: 'aftcabin',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Worktop: 1,
    FabricSaloon: 1,
    Handrail: 1,
    PleatedBlinds: 1,
    FabricCabins: 1,
    AftCabinConfig: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'FabricCabins',
      dependency: null
    },
    {
      option: 'AftCabinConfig',
      dependency: 'FabricCabins'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC45/views/aftcabin.js